<template>
  <div>
    <v-dialog
        v-model="model"
        scrollable
        @click:outside="fecharModal"
        :persistent="persistencia"
        :max-width="maxWidth"
        style="padding: 0">
      <v-card class="card-component">
        <v-card-title>{{ titulo }}</v-card-title>
        <v-card-text style="color: black">
          <p>{{ mensagemInicial }} <b>{{ mensagemMeio }}</b> {{ mensagemFinal }}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn text @click="cancelar" :color="corCancelar">{{ textCancelar }}</v-btn>
          <v-btn @click="confirmar" text :color="corConfirmar">{{ textConfirmar }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
    name: 'Confirm-modal',
    props: {
        value: {
            type: Boolean,
            required: true
        },
        mensagemInicial: String,
        mensagemMeio: String,
        mensagemFinal: String,
        persistencia: {
            type: Boolean,
            default: true
        },
        titulo: {
            type: String,
            default: 'Atenção!'
        },
        textCancelar: {
            type: String,
            default: 'Cancelar'
        },
        textConfirmar: {
            type: String,
            default: 'Excluir'
        },
        corCancelar: {
            type: String,
            default: 'black'
        },
        corConfirmar: {
            type: String,
            default: 'red'
        },
        maxWidth: {
            type: Number,
            default: 400
        }
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    methods: {
        fecharModal() {
            if (!this.persistencia) {
                this.cancelar()
            }
        },
        cancelar() {
            this.model = false
            this.$emit('modalAcaoCancelar')
        },
        confirmar() {
            this.model = false
            this.$emit('modalAcaoConfirmar')
        }
    }

}
</script>

<style scoped lang="stylus">
.card-component
  text-align start
  background-color #FFFFFF
  color #000000

</style>